﻿import { ajaxPost } from '../../utils/ajax';
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'di-payment-actions-b2c',
    props: ['blockid', 'viewmodel'],

    created() {
    },
    mounted() {
        this.model = this.viewmodel;

        this.$store.watch(state => state.digitalvalidation.pageLoader.showLoader,
            (newState) => {
                this.showLoader = newState;
            });

        this.$store.watch(state => state.digitalvalidation.alertModal.show,
            (newState) => {
                if (newState === true) {
                    this.showPopUp = true;
                    this.$store.dispatch('hideModal');
                }
            });
    },
    computed: {
    },
    data: () => ({
        model: {
        },
        showLoader: false,
        showPopUp: false
    }),
    methods: {
        tryExecuteSigningDocumentsB2CAgain() {
            var orderId = this.model.orderId;
            var dealerCode = this.model.dealerCode;
            var channelType = this.model.channelType;
            var confirmationPageUrl = this.model.confirmationPageRedirectUrl;
            var errorMessages = {
                "signContractsErrorMessage": this.model.currentPage.trySignDocumentsAgainErrorMessage,
                "approveOrderGeneralErrorMessage": this.model.currentPage.tryApproveOrderAgainErrorMessage,
                "approveOrderMissingDownPaymentPlanErrorMessage": this.model.currentPage.tryApproveOrderAgainMissingDownPaymentPlanErrorMessage,
                "approveOrderCAValidationErrorMessage": this.model.currentPage.tryApproveOrderAgainCAOrderInvalidErrorMessage
            };

            this.$store.dispatch('tryExecuteSigningDocumentsB2CAgain',
                {
                    'orderId': orderId,
                    'dealerCode': dealerCode,
                    'channelType': channelType,
                    'confirmationPageUrl': confirmationPageUrl,
                    'loaderTitle': this.model.currentPage.loaderTitle,
                    'loaderMessage': this.model.currentPage.loaderMessage,
                    'errorMessages': errorMessages
                });
        },
        tryPayAgain() {
            var orderId = this.model.orderId;
            var returnUrl = this.model.paymentRedirectUrl;
            this.showLoader = true;

            this.$store.dispatch('creditCardPayInitialize',
                {
                    'orderId': orderId,
                    'returnUrl': returnUrl,
                    'loaderTitle': this.model.currentPage.loaderTitle,
                    'loaderMessage': this.model.currentPage.loaderMessage,
                    'errorMessage': this.model.currentPage.tryPayAgainErrorMessage
                });
        },
        redirectToNetaxept() {
            var redirectUrl = this.model.netaxeptTerminalUrl;
            this.showLoader = true;

            this.$store.dispatch('redirectToNetaxeptTerminal',
                {
                    'redirectUrl': redirectUrl,
                    'loaderTitle': this.model.currentPage.loaderTitle,
                    'loaderMessage': this.model.currentPage.loaderMessage
                });
        },
        redirectToDocumentsStep() {
            var redirectUrl = this.model.digitalValidationDocumentsUrl;
            this.showLoader = true;

            this.$store.dispatch('redirectToDocumentsStepPage',
                {
                    'redirectUrl': redirectUrl,
                    'loaderTitle': this.model.currentPage.loaderTitle,
                    'loaderMessage': this.model.currentPage.loaderMessage
                });
        },
        closePopup: function () {
            this.showPopUp = false;
        }
    },
    ready: function () {
    }
}